export interface subMenuBranchLink {
  title: string;
  nz: string;
  au: string;
}

export interface ILinkInfo {
  title: string;
  targetLink: string;
  subMenuLink?: subMenuBranchLink[];
  isExternalLink: boolean;
}

export interface data {
  subMenu: string;
  linkData: string;
}

export const subMenuLinks: ILinkInfo[] = [
  {
    title: "Design Your Way",
    targetLink: "",
    isExternalLink: false,
  },
  {
    title: "Pricing",
    subMenuLink: [
      {
        title: "Apparel",
        nz: "https://cdn.fashionbiz.com/sublimation/BCL-Sales-PriceSheet-Sub-NZ-April26-01.pdf",
        au: "https://cdn.fashionbiz.com/sublimation/BCL-Sales-PriceSheet-Sub-AUS-April26-01.pdf",
      },
      {
        title: "Headwear",
        nz: "https://cdn.fashionbiz.com/sublimation/BCL-Headwear-NZ-Price-Sheet-2025-Nov.pdf",
        au: "https://cdn.fashionbiz.com/sublimation/BCL-Headwear-AUS-Price-Sheet-2025-Nov.pdf",
      },
      {
        title: "Cut and Sew",
        nz: "https://cdn.fashionbiz.com/sublimation/links/stylesheets/BCL-Sales-PriceSheet-C%26S-NZ-Feb26.pdf",
        au: "https://cdn.fashionbiz.com/sublimation/links/stylesheets/BCL-Sales-PriceSheet-C%26S-AUS-Feb26.pdf",
      },
    ],
    targetLink: "/pricing",
    isExternalLink: false,
  },
  {
    title: "Style Sheets",
    subMenuLink: [
      {
        title: "Cut & Sew Design Templates",
        nz: "https://cdn.fashionbiz.com/sublimation/BCL-Garment-Design-Templates-Cut&Sew.pdf",
        au: "https://cdn.fashionbiz.com/sublimation/BCL-Garment-Design-Templates-Cut&Sew.pdf",
      },
    ],
    targetLink: "/stylesheets",
    isExternalLink: false,
  },
  {
    title: "Engineered Fabrics",
    targetLink: "/fabrics",
    isExternalLink: false,
  },
  {
    title: "Education",
    targetLink: "/education",
    isExternalLink: false,
  },
  {
    title: "Order Form",
    targetLink:
      "https://drive.google.com/drive/folders/1hMqqSwmOzFMB5TpN86c5MkaZBQFuVuf7?usp=drive_link",
    isExternalLink: true,
  },
];
